import { EnrichmentFilterConfig } from "../ListEditDetails";
import { OverrideRule } from "../types/override-rules";

/** A tracker's source apollo config: the search profiles and the Find person switch (PREC-4399). */
export type TrackerApolloConfig = Record<string, unknown> & {
	findPersonOnSignal?: boolean;
	enrichmentFilterConfig?: EnrichmentFilterConfig;
	maxPerCompany?: number;
};

/** The step needs one search profile before the automatic search can run. */
export const hasSearchProfile = (filters: EnrichmentFilterConfig | undefined): boolean =>
	!!(filters?.first || filters?.second || filters?.third);

/**
 * The config the step saves: the switch, the profiles with their override rules, and one person
 * per company (fixed for trackers). The rest of the source's config is kept.
 */
export const trackerFindPersonConfig = <T extends object>(
	current: T | undefined,
	enabled: boolean,
	titleFilters: EnrichmentFilterConfig | undefined,
	overrideRules: OverrideRule[]
): T & TrackerApolloConfig => ({
	...((current ?? {}) as T),
	findPersonOnSignal: enabled,
	enrichmentFilterConfig: titleFilters
		? { ...titleFilters, overrideRules: overrideRules.length > 0 ? overrideRules : undefined }
		: undefined,
	maxPerCompany: 1,
});
